// get sticky header pdp height
function getStickyHeaderHeight() {
  const stickyHeader = document.getElementById('sticky-header-pdp');

  if (!stickyHeader) return 0;

  // Check if sticky header is visible (opacity > 0 and visibility is visible)
  const isVisible =
    window.getComputedStyle(stickyHeader).visibility === 'visible' &&
    parseFloat(window.getComputedStyle(stickyHeader).opacity) > 0;

  if (isVisible) {
    return stickyHeader.offsetHeight;
  }

  return 0;
}

// Update CSS variable with sticky header height
function updateStickyHeaderHeightVariable() {
  const height = getStickyHeaderHeight();
  document.documentElement.style.setProperty('--sticky-header-pdp-height', `${height}px`);
}

// Initialize and update on scroll/resize
document.addEventListener('DOMContentLoaded', function () {
  updateStickyHeaderHeightVariable();

  window.addEventListener('scroll', updateStickyHeaderHeightVariable);
  window.addEventListener('resize', updateStickyHeaderHeightVariable);
});

// Mobile product media gallery active slide tracking
function initMobileMediaGallery() {
  const mobileGallery = document.querySelector('.product__media-thumbnail-main-mobile-view ul');

  if (!mobileGallery) return;

  const slides = mobileGallery.querySelectorAll('li');

  if (slides.length === 0) return;

  // Function to update active slide based on scroll position
  function updateActiveSlide() {
    const scrollLeft = mobileGallery.scrollLeft;
    const galleryWidth = mobileGallery.offsetWidth;

    slides.forEach((slide) => {
      const slideLeft = slide.offsetLeft;
      const slideWidth = slide.offsetWidth;
      const slideCenter = slideLeft + slideWidth / 2;
      const viewportCenter = scrollLeft + galleryWidth / 2;

      // Check if this slide's center is closest to the viewport center
      const isActive = Math.abs(slideCenter - viewportCenter) < slideWidth / 2;

      if (isActive) {
        slide.classList.add('is-active');
      } else {
        slide.classList.remove('is-active');
      }
    });
  }

  // Add scroll event listener with debounce for performance
  let scrollTimeout;
  mobileGallery.addEventListener('scroll', function () {
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(updateActiveSlide, 50);
  });

  // Initialize active state
  updateActiveSlide();
}

// Initialize mobile media gallery on DOMContentLoaded
document.addEventListener('DOMContentLoaded', function () {
  initMobileMediaGallery();
});
